import PropTypes from 'prop-types';
import React from 'react';
import BodyClassName from 'react-body-classname';
export var FullScreenError = function FullScreenError(props) {
  var content;
  var _props$error = props.error,
      message = _props$error.message,
      code = _props$error.code;

  if (code && code === 404) {
    content = React.createElement("div", null, React.createElement("h1", {
      className: "title"
    }, "404"), React.createElement("p", null, "Whoops!", React.createElement("br", null), "That\u2019s not how we wanted this to go."));
  } else {
    content = React.createElement("div", null, React.createElement("h2", {
      className: "title"
    }, "We are a bit busy right now!"), React.createElement("p", null, "We\u2019re doing some heavy lifting at the moment.", React.createElement("br", null), "Check back soon!"));
  }

  return React.createElement(BodyClassName, {
    className: "body--error body--no-footer body--render-error"
  }, React.createElement("div", {
    className: "render-error"
  }, React.createElement("img", {
    className: "render-error__arm",
    src: require('../../../static/img/404-arm.png'),
    alt: "Arm",
    width: "599",
    height: "548"
  }), React.createElement("img", {
    className: "render-error__kettlebell",
    src: require('../../../static/img/404-weight.png'),
    alt: "Weight",
    width: "654",
    height: "464"
  }), React.createElement("section", {
    className: "render-error__content"
  }, content, React.createElement("div", {
    className: "hidden",
    "data-code": code
  }, message))));
};
FullScreenError.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string.isRequired,
    details: PropTypes.string,
    code: PropTypes.number
  }).isRequired
};